import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];
  static values = { variables: { type: Array, default: [] } };

  connect() {
    this.dropdown = null;
    this.selectedIndex = 0;
    this.filteredItems = [];
    this.triggerStart = null;

    this.inputTarget.addEventListener("input", () => this.check());
    this.inputTarget.addEventListener("keydown", (e) => this.handleKeydown(e));
    this.inputTarget.addEventListener("blur", () =>
      setTimeout(() => this.hide(), 150),
    );
  }

  disconnect() {
    this.hide();
  }

  check() {
    if (!this.variablesValue.length) return;

    const el = this.inputTarget;
    const text = el.value.substring(0, el.selectionStart);
    const match = text.match(/\{\{\s*([\w.]*)$/);

    if (match) {
      this.query = match[1];
      this.triggerStart = el.selectionStart - match[1].length;
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.filteredItems = this.variablesValue.filter((v) =>
      v.label.toLowerCase().includes((this.query || "").toLowerCase()),
    );

    if (!this.filteredItems.length) {
      this.hide();
      return;
    }

    if (!this.dropdown) {
      this.dropdown = document.createElement("div");
      this.dropdown.className = "tiptap-variable-dropdown";
      document.body.appendChild(this.dropdown);
    }

    this.selectedIndex = 0;
    this.render();
    this.position();
    this.dropdown.hidden = false;
  }

  hide() {
    if (this.dropdown) {
      this.dropdown.remove();
      this.dropdown = null;
    }
    this.filteredItems = [];
  }

  render() {
    this.dropdown.innerHTML = this.filteredItems
      .map(
        (v, i) =>
          `<button type="button" class="tiptap-variable-item${i === this.selectedIndex ? " selected" : ""}" data-index="${i}">${v.label}</button>`,
      )
      .join("");

    this.dropdown.querySelectorAll(".tiptap-variable-item").forEach((btn) => {
      btn.addEventListener("mousedown", (e) => {
        e.preventDefault();
        this.insert(parseInt(btn.dataset.index));
      });
    });
  }

  position() {
    const rect = this.inputTarget.getBoundingClientRect();
    // Approximate cursor position — put dropdown below textarea
    this.dropdown.style.position = "fixed";
    this.dropdown.style.left = `${rect.left}px`;
    this.dropdown.style.bottom = `${window.innerHeight - rect.top + 4}px`;
    this.dropdown.style.top = "auto";
  }

  handleKeydown(e) {
    if (!this.filteredItems.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.selectedIndex = Math.min(
        this.selectedIndex + 1,
        this.filteredItems.length - 1,
      );
      this.updateSelection();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
      this.updateSelection();
    } else if (e.key === "Enter" || e.key === "Tab") {
      if (this.dropdown && !this.dropdown.hidden) {
        e.preventDefault();
        this.insert(this.selectedIndex);
      }
    } else if (e.key === "Escape") {
      this.hide();
    }
  }

  updateSelection() {
    this.dropdown
      ?.querySelectorAll(".tiptap-variable-item")
      .forEach((btn, i) => {
        btn.classList.toggle("selected", i === this.selectedIndex);
        if (i === this.selectedIndex) btn.scrollIntoView({ block: "nearest" });
      });
  }

  insert(index) {
    const item = this.filteredItems[index];
    if (!item) return;

    const el = this.inputTarget;
    const before = el.value.substring(0, this.triggerStart - 2); // -2 for {{
    const after = el.value.substring(el.selectionStart);
    el.value = before + item.value + after;
    const cursorPos = before.length + item.value.length;
    el.setSelectionRange(cursorPos, cursorPos);
    el.focus();
    el.dispatchEvent(new Event("input", { bubbles: true }));
    this.hide();
  }
}
